import Splide from '@splidejs/splide';

( function( app ) {
  const COMPONENT = {
    main: null,
    thumbs: null,

    init: function() {
      const mainEl = document.querySelector( '.js-project-gallery-main' );
      const thumbsEl = document.querySelector( '.js-project-gallery-thumbs' );

      if ( !mainEl || !thumbsEl ) return;

      this.thumbs = new Splide( thumbsEl, {
        direction: 'ttb',
        perPage: 5,
        gap: '20px',
        height: '600px',
        pagination: false,
        arrows: false,
        rewind: true,
        isNavigation: true,
        speed: 600,
        breakpoints: {
          769: {
            direction: 'ltr',
            gap: '12px',
            height: 'unset',
          },
          768: {
            arrows: true,
          },
        },
      } );

      this.main = new Splide( mainEl, {
        type: 'slide',
        pagination: false,
        arrows: true,
        rewind: true,
        speed: 800,
        waitForTransition: false,
        breakpoints: {
          768: {
            arrows: false,
          },
        },
      } );

      this.main.sync( this.thumbs );

      this.thumbs.mount();
      this.main.mount();

      setTimeout( () => {
        this.thumbs.refresh();
      }, 50 );
    },
  };

  app.registerComponent( 'project-gallery', COMPONENT );
} )( app );
